// extracted by mini-css-extract-plugin
module.exports = {"G":"G_G__yA2Og"};